import React from 'react';
import loadable from '@loadable/component';

import useTemplateTheme from '../../../hooks/useTemplateTheme';
import { Helpers } from '../../../core/src/helpers';

const PdpOverview = loadable(() => Helpers.retryFunc(() => import('./pdp-overview')));
const BrandedOverview = loadable(() => Helpers.retryFunc(() => import('./branded-overview')));

export default ({}) => {
    const { pdpOverview } = useTemplateTheme(['pdpOverview']);
    const { variation } = pdpOverview || {};
    return variation === 'branded' ? <BrandedOverview theme={pdpOverview} /> : <PdpOverview />;
};
